import React from 'react';
import { SOCIAL_GRID_LINKS } from '../constants/site';

const SocialLinks = () => (
  <div className="grid-9-row">
    {SOCIAL_GRID_LINKS.map(({ id, label, icon, href }, index) => (
      <div key={id} className={`social-box s-${index + 1}`}>
        <a href={href} target="_blank" rel="noreferrer">
          <i className={`${icon} o-1`}></i>
          <span>{label}</span>
        </a>
      </div>
    ))}
  </div>
);

export default SocialLinks;
